import { Directive, HostListener } from "@angular/core";
import { Router } from "@angular/router";

/**
 * Ensure dynamic & relative links are pushed through Angular router
 */
@Directive({
  selector: "[hrefToRouterLink]",
})
export class HrefToRouterLinkDirective {
  constructor(private router: Router) {}

  // Identify whether element can be treated as routerLink
  private canUseRouterLink(element) {
    return (
      typeof window !== "undefined" &&
      !!element.href &&
      element.target !== "_blank" &&
      element.href.indexOf(window.location.host) > -1
    );
  }

  // Stop the browser's default behavior (navigation)
  private cancelClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener("click", ["$event"]) onClick(event) {
    const clickedElement = event.target;

    if (this.canUseRouterLink(clickedElement)) {
      this.cancelClick(event);

      this.router.navigateByUrl(clickedElement.getAttribute("href"));
    }
  }
}
